import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Box as Container } from '@node-space/ui-components'
import { Lottie } from './Animations/SimpleLottie'
import { ExternalLink } from './ExternalLink/ExternalLink'
import { LogoHeader } from './header/LogoHeader'

interface ErrorContentProps {
  errorInfo: string
  sentryTraceId?: string
}

const CONTACT = process.env.CONTACT_SALES_URL

const ErrorContent: React.FC<ErrorContentProps> = ({ errorInfo, sentryTraceId }) => {
  const { t } = useTranslation()

  return (
    <Container height="screen" width="full" flexCol className="min-h-screen bg-background-flat">
      <LogoHeader />
      <Box paddingX={60} height="full" className="">
        <Box flexCol justify="center" paddingY={32} gap={32} className="min-h-full">
          <Lottie src="no-results" />
          <Box flexCol gap={12} className={`max-w-[600px] `}>
            <h1 className="text-h1 text-foreground-prominent">{t('errorMessages.errorOccured')}</h1>
            <Box tag="p" className={`text-foreground-subdued `}>
              <details>
                <summary className="text-foreground-subdued">
                  {t('errorMessages.clickDetails')}
                </summary>
                {errorInfo}
              </details>
              {t('errorMessages.please')}{' '}
              <ExternalLink href={CONTACT}>{t('errorMessages.contactSupport')}</ExternalLink>{' '}
              {t('errorMessages.or')}{' '}
              <Button variant="ghost" noPadding onClick={() => window.location.reload()}>
                {t('errorMessages.reload')}
              </Button>
              {sentryTraceId && (
                <Box>
                  {t('errorMessages.traceId')}: {sentryTraceId}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

export default ErrorContent
